import React, { useState } from 'react';
import { Search, Check, FileText, MoreVertical, ChevronDown } from 'lucide-react';
import PortalBackground from '../components/PortalBackground';

const TakeoffProjects = () => {
  const [searchQuery, setSearchQuery] = useState('');
  
  // Sample project data (just the first entry)
  const projects = [
    {
      id: 1,
      name: 'Harrison #3 Project',
      status: 'Bidding',
      bidDate: 'Mar 11th 2025 10:25 AM',
      assignedTo: 'Orzulak, Raymond',
      notes: ''
    }
  ];

  return (
    <div className="relative min-h-screen flex flex-col">
      <PortalBackground />
      <div className="relative flex flex-col flex-1 min-h-0">
      {/* Header */}
      <header className="p-4 border-b border-gray-200">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-4">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <Search className="h-4 w-4 text-gray-500" />
              </div>
              <input
                type="search"
                className="pl-10 py-2 px-4 border border-gray-300 rounded-md w-60 focus:outline-none"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <button className="bg-green-600 text-white py-2 px-4 rounded-md">
              Search
            </button>
            <button className="text-green-600 py-2 px-4 border border-gray-300 rounded-md">
              Reset
            </button>
          </div>
          <div className="flex items-center gap-2">
            <button className="bg-green-600 text-white py-2 px-4 rounded-md">
              New Project
            </button>
            <button className="p-1 text-green-600">
              <ChevronDown className="h-5 w-5" />
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 p-4">
        {/* Table Headers */}
        <div className="grid grid-cols-6 text-left text-sm font-medium text-gray-600 border-b border-gray-200 pb-2">
          <div className="px-2">PROJECT NAME</div>
          <div className="px-2">STATUS</div>
          <div className="px-2 flex items-center">
            BID DATE <ChevronDown className="h-4 w-4 ml-1" />
          </div>
          <div className="px-2">LOCATION</div>
          <div className="px-2">ASSIGNED TO</div>
          <div className="px-2">NOTES</div>
        </div>

        {/* Project Row */}
        <div className="grid grid-cols-6 text-left py-4 border-b border-gray-200 items-center">
          <div className="px-2 font-medium">
            <div className="flex items-center gap-2">
              Harrison #3 Project
              <div className="flex gap-1">
                <button className="p-1 text-gray-500 hover:text-gray-700">
                  <FileText className="h-4 w-4" />
                </button>
                <button className="p-1 text-gray-500 hover:text-gray-700">
                  <Check className="h-4 w-4" />
                </button>
              </div>
            </div>
          </div>
          <div className="px-2">
            <div className="bg-gray-200 text-center py-1 px-3 rounded-md text-sm w-32">
              Bidding
            </div>
          </div>
          <div className="px-2 text-sm">Mar 11th 2025 10:25 AM</div>
          <div className="px-2"></div>
          <div className="px-2">
            <div className="flex items-center gap-2">
              <div className="bg-purple-500 text-white rounded-full h-8 w-8 flex items-center justify-center text-sm">
                RO
              </div>
              <div className="text-sm flex items-center">
                Orzulak, Raymond
                <ChevronDown className="h-4 w-4 ml-1 text-gray-400" />
              </div>
            </div>
          </div>
          <div className="px-2 text-right">
            <button className="p-1 text-gray-500 hover:text-gray-700">
              <MoreVertical className="h-5 w-5" />
            </button>
          </div>
        </div>
      </main>
      </div>
    </div>
  );
};

export default TakeoffProjects; 